'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Use `Label` for labels. Renders a native `label` element.
 *
 * @example
 * <Label data-size='lg' weight='medium'>Label</Label>
 */
const Label = forwardRef(function Label({ className, weight = 'medium', asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'label';
    return (jsx(Component, { ref: ref, className: cl('ds-label', className), "data-weight": weight, ...rest }));
});

export { Label };
